import { Box, Typography } from '@mui/material';
import ExoAvatar from '../../ExoAvatar';
import CategoryIcon from '@mui/icons-material/Category';
import { useTranslation } from 'react-i18next';

export const SalesObjectMatch = ({ match }) => {
  const { t } = useTranslation();

  const { element, score } = match;
  const { title, image, nr } = element || {};
  return (
    <Box className="flex items-center gap-2 w-full">
      {image ? (
        <img
          src={image?.temporaryUrl}
          className=" h-[40px] w-[60px] object-cover rounded-md"
        />
      ) : (
        <ExoAvatar
          picture={image?.temporaryUrl}
          type={image ? 'company' : 'contact'}
          icon={<CategoryIcon sx={{ fontSize: '30px' }} />}
          size="40px"
        />
      )}
      <Box className="flex justify-between items-center w-full">
        <Box>
          <Typography fontWeight={600}>{title}</Typography>
          <Typography className="opacity-50">{nr}</Typography>
        </Box>
        <Box>
          <Typography variant="h4" textAlign="right">
            {score}%
          </Typography>
          <Typography textAlign="right" className="opacity-50">
            {t('matching')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
